// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import * as React from "react";

const IconLock: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" transform="translate(1 1)">
                <circle cx="15" cy="15" r="15" fill="#E7EBEF" stroke="#001F60" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M12.2500004,7.875 L12.2500004,12.25 C12.2500004,13.215234 11.4652345,14 10.5,14 L1.75000042,14 C0.783398688,14 0,13.216328 0,12.2746092 L0,7.89960921 C0,6.93300748 0.783398271,6.14960921 1.75,6.14960921 L2.1875,6.125 L2.1875,3.9375 C2.1875,1.76613271 3.95390642,0 6.125,0 C8.29609358,0 10.0625,1.76613271 10.0625,3.9375 L10.0625,4.375 L8.3125,4.375 L8.3125,3.9375 C8.3125,2.73109388 7.33085954,1.75 6.125,1.75 C4.91914046,1.75 3.9375,2.73109388 3.9375,3.9375 L3.9375,6.125 L10.5,6.125 C11.465234,6.125 12.2500004,6.90976554 12.2500004,7.875 L12.2500004,7.875 Z"
                    transform="translate(8.875 7.75)"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconLock);
